module.exports = __webpack_public_path__ + "static/media/logoShell.f7573bea.png";